// extracted by mini-css-extract-plugin
export default {"markdownBlock":"Markdown_markdownBlock__7bBfx","markdown-truncate":"Markdown_markdown-truncate__7LN0c"};